import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

import styled from 'styled-components';

import { Header, Layout as VFLayout, NewVersionModal, useNewVersionCheck, useTheme } from '@vattenfall/wind-common-fe';
import { Navigation } from '../navigation';
import { IS_VERSION_CHECK_ENABLED, VERSION_CHECK_TARGETS } from '../../config';
import { Box } from '@mui/material';

const Main = styled.main<{ muiTheme: any, children?: React.ReactNode }>`
    margin: 73px 0 0 250px;
    min-height: 80vh;
    background: #fff;
    padding: 8px 0;

    ${({ muiTheme }) => muiTheme.breakpoints.down('sm')} {
        margin: 73px 0 0 0;
    }
`;

const Layout: FC = () => {
  const theme = useTheme();
  const { showNewVersionPopup, refreshApp } = useNewVersionCheck({
    targets: VERSION_CHECK_TARGETS,
    enabled: IS_VERSION_CHECK_ENABLED,
  });

  return (
    <VFLayout>
      <Navigation />
      <Box sx={{ width: '100%' }}>
        <Header
          position="fixed"
          title="QUALITY MANAGEMENT TOOL"
        />
        <Main muiTheme={theme}>
          <Outlet />
        </Main>
      </Box>
      <NewVersionModal isOpen={showNewVersionPopup} onRefresh={refreshApp} />
    </VFLayout>
  );
};

export { Layout };
